import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumEmptyPageModule, EmptyPage, EmptyPageConfig } from '@celum/common-components';
import { resolveAssetPath } from '@celum/formats/shared';

@Component({
  selector: 'no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss'],
  imports: [TranslatePipe, CelumEmptyPageModule]
})
export class NoPermissionComponent {
  public messageKey = input('FORMATS.NO_PERMISSION');

  protected noPermissionPageConfig = computed<EmptyPageConfig>(() =>
    EmptyPage.noActionConfig('no-formats-permission', resolveAssetPath('no-formats-permission'), this.messageKey(), 'normal', 232, '40rem')
  );
}
